export default __webpack_public_path__ + "static/media/log-in.e2a138c2.svg";